import { styled } from '@mui/material';

const PREFIX = 'GridSkeleton';

export const classes = {
  row: `${PREFIX}-row`,
  cell: `${PREFIX}-cell`,
};

export const Root = styled('div')(() => ({
  [`& .${classes.row}`]: {
    display: 'flex',
    justifyContent: 'space-around',
    flexWrap: 'nowrap',
  },

  [`& .${classes.cell}`]: {
    margin: 2,
    flexGrow: 1,
    '&:first-of-type': {
      flexGrow: 2,
    },
  },
}));